var resizeObservers = [];
export { resizeObservers };